export const stringifyRange = (from: string, to: string): string => {
  const format = (value: string): string => value || '*';

  return `[${format(from)},${format(to)}]`;
};
